import { Box, Card, Group, Skeleton, Stack } from '@mantine/core';
import { TextSkeleton } from '@repo/foundations';
import type { WidgetSize } from '../../interfaces';
import { getWidgetSpan } from '../AnalyticsPage/utils/utils';
import { WIDGET_SIZE_MAP } from '../HomePage/components/WidgetContainer/constants';
import { useStyles } from './AnalyticsListPage.styles';

export type CachedReportView = { size: WidgetSize }[];

interface AnalyticsReportCardLoadingProps {
	reportView: CachedReportView;
}

export default function AnalyticsReportCardLoading({
	reportView,
}: AnalyticsReportCardLoadingProps) {
	const { classes, theme } = useStyles();

	const moreThanOneRow =
		reportView
			.slice(0, 6)
			.reduce((acc, widget) => acc + Number(WIDGET_SIZE_MAP[widget.size]), 0) >
		12;

	return (
		<Card className={classes.card}>
			<Box className={classes.imageContainer}>
				<Box
					style={{
						height: '100%',
						display: 'grid',
						gridTemplateColumns: 'repeat(12, 1fr)',
						gridTemplateRows: moreThanOneRow
							? 'repeat(2, 1fr)'
							: 'repeat(1, 1fr)',
						gap: theme.spacing.xs,
						padding: 0,
					}}
				>
					{reportView.slice(0, 6).map((widget, idx) => (
						<Skeleton
							key={`image-${idx}`} /* eslint-disable-line */
							style={{
								gridColumn: getWidgetSpan(widget.size),
								height: '100%',
								overflow: 'hidden',
								position: 'relative',
								borderRadius: theme.radius.sm,
								padding: 0,
							}}
						/>
					))}
				</Box>
			</Box>
			<Stack spacing="3xs" pt="md">
				<TextSkeleton size="sm" fw="bold" />
				<Group position="left" noWrap spacing="xs">
					<TextSkeleton size="xs" text="Last edited today" />
					&middot;
					<TextSkeleton size="xs" text="0 views" />
				</Group>
			</Stack>
		</Card>
	);
}
